module.exports = __webpack_public_path__ + "static/media/1002065MF.f4a0d381.jpg";